module.exports = __webpack_public_path__ + "static/img/2.a2814ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/2.png
// module id = nNDb
// module chunks = 0